

































import MainMenu from "./components/MainMenu.vue";
import {
  DEMO_TITLES,
  DEMO_DESCRIPTIONS,
  DEMO_MODEL_LINKS,
} from "./data/demo-titles";
import Component from "vue-class-component";
import Vue from "vue";

@Component({
  components: { MainMenu },
})
export default class App extends Vue {
  showNav: boolean;
  hasWebGL: boolean;

  constructor() {
    super();
    this.showNav = false;
    this.hasWebGL = true;
  }

  get currentView() {
    const path = this.$route.path;
    return path.replace(/^\//, "") || "/";
  }

  get currentTitle() {
    const title = DEMO_TITLES[this.currentView];
    if (title) {
      return title;
    } else {
      return "Limin Zheng";
    }
  }
  get currentDescription() {
    const description = DEMO_DESCRIPTIONS[this.currentView];
    if (description) {
      return description;
    } else {
      return "current description";
    }
  }
  get currentLink() {
    const link = DEMO_MODEL_LINKS[this.currentView];
    if (link) {
      return link;
    } else {
      return "";
    }
  }
}
